export class SeoService {
  static getPageTitle(page: string) {
    return `${page} | Loopic - CasparCG HTML graphics creation tool`;
  }
}
